export const ICON = {
  SIZE: { XLARGE: "xlarge", LARGE: "large", MEDIUM: "medium", SMALL: "small" },
};